import { useMemo } from "react";
import ScrollableTable from "src/components/shared/ScrollableTable/ScrollableTable";

import { useSelector } from "../../../../redux/hooks";
import { deepClone } from "../../../../utils";
import { tableData } from "./ManagementTable.utils";

interface Props<T> {
  section: keyof typeof tableData;
  data: T[];
  loading: boolean;
}

const ManagementTable = <T extends Record<string, any>>({
  section,
  ...props
}: Props<T>) => {
  const { isSendingWelcomeEmails } = useSelector(
    state => state.managementSlice,
  );

  const parsedTableData: any = useMemo(() => {
    if (!tableData[section]) return {};
    if (isSendingWelcomeEmails && section === "_users") {
      const parsed = deepClone(tableData[section].headers);
      parsed.unshift({ label: "Select", name: "select-all" });
      return { ...tableData[section], headers: parsed };
    }
    return tableData[section];
  }, [tableData, section, props, isSendingWelcomeEmails]);

  if (tableData[section]) {
    return (
      <div style={{ marginTop: 10 }}>
        <ScrollableTable {...props} {...parsedTableData} />
      </div>
    );
  }

  return <></>;
};

export default ManagementTable;
